import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IRescheduleRequest } from '../../../core/models/appointment.model';
import { ERescheduleRequestStatus } from '../../../core/enums/reschedule-request-status.enum';

/**
 * One request to move a meeting: who asked, which meeting, and the two times side by side. The
 * agenda card and the "all requests" dialog draw the same row; only the dialog also names the
 * status, because there every request is listed, resolved ones included.
 */
@Component({
  selector: 'coach-reschedule-request-row',
  templateUrl: './reschedule-request-row.component.html',
  styleUrl: './reschedule-request-row.component.scss',
})
export class RescheduleRequestRowComponent {
  @Input() request!: IRescheduleRequest;
  /** On in the dialog, where resolved requests appear next to pending ones. */
  @Input() showStatus = false;
  @Input() isBusy = false;

  @Output() approveRequested = new EventEmitter<IRescheduleRequest>();
  @Output() rejectRequested = new EventEmitter<IRescheduleRequest>();

  statuses = ERescheduleRequestStatus;

  isPending(): boolean {
    return this.request.status === ERescheduleRequestStatus.Pending;
  }

  /** Colours the avatar; the level travels with the student on the request listing. */
  levelKey(): string | null {
    return this.request.appointment?.student?.userInfo?.level?.key ?? null;
  }

  statusKey(): string {
    switch (this.request.status) {
      case ERescheduleRequestStatus.Approved:
        return 'agenda.reschedule_status_approved';
      case ERescheduleRequestStatus.Rejected:
        return 'agenda.reschedule_status_rejected';
      default:
        return 'agenda.reschedule_status_pending';
    }
  }
}
